import { ConfigurationSynopticTemplateResponse } from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template/configuration-synoptic-template.dto'
import { ConfigurationSynopticTemplateOntologyResponse } from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template-ontology/configuration-synoptic-template-ontology.dto'

export enum ConfigurationTemplatesSynopticTemplatesTabIndex {
    FORM_DATA = 0,
    STRUCTURE = 1,
    ONTOLOGIES = 2,
    EXTERNAL_DOCUMENTATION = 3
}

export interface ConfigurationTemplatesSynopticTemplatesModalState {
    activeTabIndex: number
    synopticTemplate: Partial<ConfigurationSynopticTemplateResponse>
    ontologies: ConfigurationSynopticTemplateOntologyResponse[]
}
export const initialConfigurationTemplatesSynopticTemplatesModalState =
    (): ConfigurationTemplatesSynopticTemplatesModalState => ({
        activeTabIndex: ConfigurationTemplatesSynopticTemplatesTabIndex.FORM_DATA,
        synopticTemplate: {
            active: true,
            title: '',
            tree: []
        },
        ontologies: []
    })
